"use client";
import { QuickRatioResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: QuickRatioResult;
  translations: ToolsTranslations['quickRatio'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-sm text-gray-600 mb-1">{translations.resultDecimalLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.ratio !== null ? result.ratio.toFixed(2) : '—'}</div>
      </div>
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-sm text-gray-600 mb-1">{translations.resultPercentLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.percent !== null ? `${result.percent} %` : '—'}</div>
      </div>
      <p className="text-sm text-gray-600">{translations.formulaNote}</p>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600">{result.message}</p>
      )}
    </div>
  );
}


